import Vue from 'vue'
import Router from 'vue-router'
import i18n from '@/lang'
import iDalgoLogin from '@/views/iDalgo-Login'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'root',
      redirect: { name: 'login' }
    },
    {
      path: '/login',
      name: 'login',
      component: iDalgoLogin

    },
    {
      path: '/login/sso',
      name: 'loginSSO',
      component: iDalgoLogin,
      props: { showSSOForm: true }
    }
  ]
})

router.beforeEach((to, from, next) => {
  // Hack to display i18n keys
  if (to.query && typeof to.query.iDebug !== 'undefined') {
    i18n.locale = 'iDebug'
  }
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js